import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import useArtistQueryLikedOnly from '../../hooks/queries/useArtistQueryLikedOnly';

export const useShowLoungeBanner = () => {
  const [isShowBanner, setIsShowBanner] = useState(false);

  const [searchParams] = useSearchParams();
  const categoryGroup = searchParams.get('categoryGroup');

  const { data: likedArtists, isLoading } = useArtistQueryLikedOnly();

  const isWishzen = likedArtists?.some((artist) => artist.artistId === 'nctwish');

  useEffect(() => {
    if (isLoading) return;
    if (isWishzen) {
      setIsShowBanner(true);
    }
  }, [isWishzen, isLoading]);

  const isWishLounge = categoryGroup === 'nctwish';

  useEffect(() => {
    if (isWishLounge) {
      setIsShowBanner(true);
    }
  }, [isWishLounge]);

  return {
    isShowBanner,
    setIsShowBanner,
    isWishLounge
  };
};
